module.exports = __webpack_public_path__ + "img/3.b52d6bbb.jpg";